module.exports = __webpack_public_path__ + "img/delrio.jpg?29b1df1171cac53241051a6ce09c628d";